import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/components/chatting/ChatBoxClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/components/contactUs/ContactUsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/components/footer/FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/components/navbar/NavbarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarProvider"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/contexts/NavbarContext.tsx");
